export function isValidRedirect(url: string | null | undefined): boolean {
  if (!url) {
    return false;
  }
  // 1. Must be a relative path starting with '/'
  // 2. Must not start with '//', '/\\', or contain '..' to prevent directory traversal.
  // 3. Must not contain protocol prefixes like 'http:', 'https:', 'javascript:'
  const isSafe = /^\/(?!\/|\\)[^?#]*?(?:\?[^#]*)?(?:#.*)?$/.test(url) && !url.includes('..');

  if (!isSafe) {
    console.warn(`Blocked potentially unsafe redirect URL: ${url}`);
    return false;
  }

  // 4. Prevent loops: disallow redirects to auth pages
  const pathname = url.split('?')[0] || '';
  if (pathname.startsWith('/login') || pathname.startsWith('/auth')) {
    console.warn(`Blocked redirect to auth-related path to prevent loops: ${url}`);
    return false;
  }

  return true;
}
